import Vue from 'vue';
import service from './base.service'
import {AxiosPromise} from 'axios';
import {AppResponse} from '@/share/response';
import {BabyFilter, CategoryHomeModel} from "@/share";

export class CategoryService extends Vue {
  private RESOURCE = 'front/categories';

  public list($params: BabyFilter): AxiosPromise<AppResponse<CategoryHomeModel[]>> {
    return service.get<AppResponse<CategoryHomeModel[]>>(this.RESOURCE, {params: $params});
  }

  public growTree($params: BabyFilter): AxiosPromise<AppResponse<any>> {
    return service.get<AppResponse<any>>(`${this.RESOURCE}/grow-tree`, {params: $params});
  }
}
